import {  applyMiddleware, legacy_createStore  as createStore} from 'redux';
import reducer from '../reducers/index.reducer';
// import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { injectStore } from '../utils/loanTypeUtil';

const middlewares = [
	// createLogger(),
	thunkMiddleware
];

export let store = null;

export default function configureStore({ initialState }) {
	store = createStore(reducer, initialState, applyMiddleware(...middlewares));
	// Make the store available to loanTypeUtil (used by api-factory getLoanType)
	injectStore(store);
	if (module.hot) {
	

		// enable webpack hot module replacement for reducers
		module.hot.accept('../reducers/index.reducer', () => {
			// `default` is to extract the default entity from the export. 
			const nextReducer = require('../reducers/index.reducer').default;
			store.replaceReducer(nextReducer);
		});
	}

	return store;

}